import { inject, PLATFORM_ID } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

import { LegalAcknowledgementsStore } from 'src/app/features/check-in/store/legal-acknowledgements.store';
import { AcknowledgementType } from 'src/app/core/enums/acknowledgement-type.enum';

/**
 * Resolver to load acknowledgement into store based on route data
 * Works with static acknowledgement routes to ensure valid data is available
 * Initializes store and loads legal acknowledgement data before component activation
 * Only runs in browser to avoid SSL issues during SSR
 */
export const legalAcknowledgementResolver: ResolveFn<boolean> = async (
  route,
) => {
  const platformId = inject(PLATFORM_ID);

  // Skip during SSR - component will handle loading
  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  const store = inject(LegalAcknowledgementsStore);
  const router = inject(Router);

  const acknowledgementType: AcknowledgementType =
    route.data['acknowledgementType'];

  try {
    await store.loadAcknowledgementDetails(acknowledgementType);
    return true;
  } catch {
    router.navigate(['/not-found']);
    return false;
  }
};
